/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */

// import $ from 'jquery';
import mobileNav from './components/mobileNav';
import accessibleMenu from './components/accesibleMenu';
import scrolled from './components/scrolled';
//import inView from './components/element-in-view';
//import tinySlider from './components/tinySlider';
//import smoothScroll from './components/smoothScroll';
import backToTop from './components/backToTop';

mobileNav();
accessibleMenu();
scrolled();
//inView();

/// Back To Top button
backToTop();

/// Smooth Scroll navigation
// smoothScroll();

document.addEventListener('DOMContentLoaded', function () {
  // remove type="" attribute in <style></style> and <script></script>
  const scriptJsArr = Array.from(document.querySelectorAll('script'));
  const styleCssArr = Array.from(document.querySelectorAll('style'));

  scriptJsArr.forEach(function (scriptJs) {
    scriptJs.removeAttribute('type');
  });

  styleCssArr.forEach(function (styleCss) {
    styleCss.removeAttribute('type');
  });

  // Add class .site-container--sidebar if there is a sidebar
  const asideArea = document.querySelector('#sidebar');
  const contentArea = document.querySelector('.site-container');

  if (asideArea) {
    contentArea.classList.add('site-container--sidebar');
  }

  // Slider init
  // if (document.querySelector('.slider')) {
  //   tinySlider();
  // }
});
